import { render } from "./opportunity-header.vue?vue&type=template&id=23422092&ts=true"
import script from "./opportunity-header.vue?vue&type=script&lang=ts"
export * from "./opportunity-header.vue?vue&type=script&lang=ts"

import "./opportunity-header.vue?vue&type=style&index=0&id=23422092&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__